import { ArticleSortOptionEnum } from "~/enums/ArticleSortOptionEnum";

export class SearchDataModel {
  constructor(
    skip: number = 0,
    limit: number = 0,
    sortBy: number = ArticleSortOptionEnum.DATE,
    applyMagazineFilters: boolean = false,
    useMagazineProjection: boolean = false
  ) {
    this.skip = skip;
    this.limit = limit;
    this.sortby = sortBy;
    this.applyMagazineFilters = applyMagazineFilters;
    this.useMagazineProjection = useMagazineProjection;
  }

  public limit: number;
  public skip: number;
  public sortby: number;
  public applyMagazineFilters: boolean;
  public useMagazineProjection: boolean;
}
